/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Or_Shoot_Share_ConnectInputs */

const en_or_shoot_share_connect = /** @type {(inputs: Or_Shoot_Share_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Shoot Share Connect`)
};

const es_or_shoot_share_connect = /** @type {(inputs: Or_Shoot_Share_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Shoot Share Connect`)
};

const fr_or_shoot_share_connect = /** @type {(inputs: Or_Shoot_Share_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Shoot Share Connect`)
};

const de_or_shoot_share_connect = /** @type {(inputs: Or_Shoot_Share_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Shoot Share Connect`)
};

const ja_or_shoot_share_connect = /** @type {(inputs: Or_Shoot_Share_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Shoot Share Connect`)
};

const zh_or_shoot_share_connect = /** @type {(inputs: Or_Shoot_Share_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Shoot Share Connect`)
};

const ar_or_shoot_share_connect = /** @type {(inputs: Or_Shoot_Share_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Shoot Share Connect`)
};

const id_or_shoot_share_connect = /** @type {(inputs: Or_Shoot_Share_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Shoot Share Connect`)
};

const it_or_shoot_share_connect = /** @type {(inputs: Or_Shoot_Share_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Shoot Share Connect`)
};

const ru_or_shoot_share_connect = /** @type {(inputs: Or_Shoot_Share_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Shoot Share Connect`)
};

const pt_or_shoot_share_connect = /** @type {(inputs: Or_Shoot_Share_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Shoot Share Connect`)
};

const ko_or_shoot_share_connect = /** @type {(inputs: Or_Shoot_Share_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Shoot Share Connect`)
};

/**
* | output |
* | --- |
* | "\| Shoot Share Connect" |
*
* @param {Or_Shoot_Share_ConnectInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const or_shoot_share_connect = /** @type {((inputs?: Or_Shoot_Share_ConnectInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Or_Shoot_Share_ConnectInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_or_shoot_share_connect(inputs)
	if (locale === "es") return es_or_shoot_share_connect(inputs)
	if (locale === "fr") return fr_or_shoot_share_connect(inputs)
	if (locale === "de") return de_or_shoot_share_connect(inputs)
	if (locale === "ja") return ja_or_shoot_share_connect(inputs)
	if (locale === "zh") return zh_or_shoot_share_connect(inputs)
	if (locale === "ar") return ar_or_shoot_share_connect(inputs)
	if (locale === "id") return id_or_shoot_share_connect(inputs)
	if (locale === "it") return it_or_shoot_share_connect(inputs)
	if (locale === "ru") return ru_or_shoot_share_connect(inputs)
	if (locale === "pt") return pt_or_shoot_share_connect(inputs)
	return ko_or_shoot_share_connect(inputs)
});